export default __webpack_public_path__ + "static/media/SPPL _Fiscal_2023.64f36234.pdf";